import { Icon, IconsEnum } from 'components/Icons';

import styles from './SportNavMobileHeader.module.scss';
import { toggleNavMobile } from 'features/sport/sportSlice';
import { useAppDispatch } from 'lib/centralStore';

export type SportNavMobileHeaderProps = {
  label: string;
};

export const SportNavMobileHeader = ({ label }: SportNavMobileHeaderProps) => {
  const dispatch = useAppDispatch();

  return (
    <div className={styles.container}>
      <span className={styles.text}>{label}</span>
      <button type="button" className={styles.button} onClick={() => dispatch(toggleNavMobile(false))}>
        <Icon iconId={IconsEnum.CLOSE} className={styles.icon} color={'var(--color-on-bg-primary)'} />
      </button>
    </div>
  );
};
